import React from "react";
import ForgotPasswordLayer from "../components/auth/ForgotPasswordLayer";

const ForgotPasswordPage = () => {
  return (
    <>
      {/* ForgotPasswordLayer */}
      <ForgotPasswordLayer />
    </>
  );
};

export default ForgotPasswordPage;
